var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "subheader" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "main-container" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { attrs: { id: "container" } }, [
                _c(
                  "div",
                  { attrs: { id: "list-header-container" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fv cc",
                        staticStyle: { width: "100%", height: "80px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fh cb",
                            staticStyle: { width: "100%", height: "50px" },
                            on: { click: _vm.showSortMenu }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.txtBusqueda,
                                  expression: "txtBusqueda"
                                }
                              ],
                              attrs: {
                                id: "busqueda",
                                type: "text",
                                placeholder:
                                  "Búsqueda por código o nombre del producto"
                              },
                              domProps: { value: _vm.txtBusqueda },
                              on: {
                                keyup: _vm.onKeyDownHandler,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.txtBusqueda = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showSortButton,
                                    expression: "showSortButton"
                                  }
                                ],
                                staticClass: "fv cc",
                                staticStyle: {
                                  width: "32px",
                                  height: "32px",
                                  "border-radius": "20px",
                                  background: "#4969B2",
                                  "margin-left": "10px",
                                  color: "white",
                                  "font-size": "8px"
                                },
                                attrs: { id: "sortSelected" }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "18px",
                                    height: "18px"
                                  },
                                  attrs: { src: _vm.imageSort }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { width: "100%", height: "30px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.seleccion != 1,
                                    expression: "seleccion != 1"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "seleccion",
                                    on: { click: _vm.ckCategoria }
                                  },
                                  [_vm._v(_vm._s(_vm.nombreCategoria))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.nombreCategoria.length > 0,
                                        expression: "nombreCategoria.length>0"
                                      }
                                    ],
                                    staticClass: "seleccion",
                                    attrs: { id: "separador" }
                                  },
                                  [_vm._v("> ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "seleccion",
                                    on: { click: _vm.ckSubcategoria }
                                  },
                                  [_vm._v(_vm._s(_vm.nombreSubcategoria))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSortOptions,
                              expression: "showSortOptions"
                            }
                          ],
                          staticStyle: {
                            height: "200px",
                            position: "absolute",
                            "margin-top": "130px",
                            "margin-left": "244px",
                            "z-index": "99"
                          },
                          attrs: { id: "sortOptions" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(1)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_alf_asc.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "8px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Alfabetico A a Z                      \n                   "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              staticStyle: { "margin-top": "5px" },
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(2)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_alf_des.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "8px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Alfabetico Z a A                      \n                   "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              staticStyle: { "margin-top": "5px" },
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(3)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_cod_asc.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "8px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Código Menor a Mayor                      \n                   "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              staticStyle: { "margin-top": "5px" },
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(4)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_cod_des.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "9px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Código Mayor a Menor                     \n                   "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              staticStyle: { "margin-top": "5px" },
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(5)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_precio_asc.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "9px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Precio Menor a Mayor\n                   "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fh cc",
                              staticStyle: { "margin-top": "5px" },
                              on: {
                                click: function($event) {
                                  _vm.sortProductos(6)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "fv cc",
                                  staticStyle: {
                                    width: "32px",
                                    height: "32px",
                                    "border-radius": "20px",
                                    background: "#4969B2",
                                    "margin-left": "10px",
                                    color: "white",
                                    "font-size": "8px"
                                  },
                                  attrs: { id: "sortSelected" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      height: "18px"
                                    },
                                    attrs: { src: "/dist/icon_precio_des.png" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fh cc",
                                  staticStyle: {
                                    "font-size": "9px",
                                    color: "white",
                                    background: "#5C666F",
                                    width: "100px",
                                    height: "22px",
                                    "border-radius": "5px",
                                    "margin-left": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                       Precio Mayor a Menor\n                   "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.show
                  ? _c(
                      "div",
                      { attrs: { id: "list-container" } },
                      _vm._l(_vm.items, function(item) {
                        return _vm.seleccion == 1 ||
                          _vm.seleccion == 2 ||
                          ((_vm.seleccion == 3 || _vm.seleccion == 4) &&
                            item.Precio)
                          ? _c("item-producto", {
                              attrs: { id: "list-prod", item: item },
                              on: { setItem: _vm.setSelection }
                            })
                          : _vm._e()
                      })
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "btnContainer" } }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showBtnCarrito,
                        expression: "showBtnCarrito"
                      }
                    ],
                    attrs: { id: "btnCarrito" },
                    on: { click: _vm.btnCarrito }
                  },
                  [_vm._v("IR AL CARRITO")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: {
                    width: "100vw",
                    height: "4vh",
                    background: "#44C7F4",
                    color: "white",
                    font: "size 12px"
                  }
                },
                [_vm._v("Nuevo Pedido")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv cc",
                  staticStyle: { width: "100vw", height: "15vh" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh cb",
                      staticStyle: { width: "100%", height: "50px" },
                      on: { click: _vm.showSortMenu }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.txtBusqueda,
                            expression: "txtBusqueda"
                          }
                        ],
                        staticStyle: { width: "70%", "font-size": "11px" },
                        attrs: {
                          id: "busqueda",
                          type: "text",
                          placeholder:
                            "Búsqueda por código o nombre del producto"
                        },
                        domProps: { value: _vm.txtBusqueda },
                        on: {
                          keyup: _vm.onKeyDownHandler,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.txtBusqueda = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSortButton,
                              expression: "showSortButton"
                            }
                          ],
                          staticClass: "fv cc",
                          staticStyle: {
                            width: "32px",
                            height: "32px",
                            "border-radius": "20px",
                            background: "#4969B2",
                            "margin-left": "10px",
                            color: "white",
                            "font-size": "8px"
                          },
                          attrs: { id: "sortSelected" }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { src: _vm.imageSort }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.seleccion != 1,
                          expression: "seleccion != 1"
                        }
                      ],
                      staticClass: "fh cc",
                      staticStyle: { width: "100%", "margin-top": "10px" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "seleccion",
                          on: { click: _vm.ckCategoria }
                        },
                        [_vm._v(_vm._s(_vm.nombreCategoria))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.nombreCategoria.length > 0,
                              expression: "nombreCategoria.length>0"
                            }
                          ],
                          staticClass: "seleccion",
                          attrs: { id: "separador" }
                        },
                        [_vm._v("> ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "seleccion",
                          on: { click: _vm.ckSubcategoria }
                        },
                        [_vm._v(_vm._s(_vm.nombreSubcategoria))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSortOptions,
                        expression: "showSortOptions"
                      }
                    ],
                    staticStyle: {
                      height: "200px",
                      position: "absolute",
                      "margin-top": "5px",
                      "margin-left": "192px",
                      "z-index": "99",
                      background: "white"
                    },
                    attrs: { id: "sortOptions" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        on: {
                          click: function($event) {
                            _vm.sortProductos(1)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_alf_asc.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "8px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Alfabetico A a Z                      \n                   "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function($event) {
                            _vm.sortProductos(2)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_alf_des.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "8px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Alfabetico Z a A                      \n                   "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function($event) {
                            _vm.sortProductos(3)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_cod_asc.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "8px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Código Menor a Mayor                      \n                   "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function($event) {
                            _vm.sortProductos(4)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_cod_des.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "9px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Código Mayor a Menor                     \n                   "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function($event) {
                            _vm.sortProductos(5)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_precio_asc.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "9px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Precio Menor a Mayor\n                   "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function($event) {
                            _vm.sortProductos(6)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              "border-radius": "20px",
                              background: "#4969B2",
                              "margin-left": "10px",
                              color: "white",
                              "font-size": "8px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { src: "/dist/icon_precio_des.png" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              "font-size": "9px",
                              color: "white",
                              background: "#5C666F",
                              width: "100px",
                              height: "22px",
                              "border-radius": "5px",
                              "margin-left": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                       Precio Mayor a Menor\n                   "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.show
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "86vw",
                        height: "60vh",
                        "margin-left": "8vw"
                      },
                      attrs: { id: "list-container" }
                    },
                    _vm._l(_vm.items, function(item) {
                      return _vm.seleccion == 1 ||
                        _vm.seleccion == 2 ||
                        ((_vm.seleccion == 3 || _vm.seleccion == 4) &&
                          item.Precio)
                        ? _c("item-producto", {
                            attrs: { id: "list-prod", item: item },
                            on: { setItem: _vm.setSelection }
                          })
                        : _vm._e()
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: { width: "100%", height: "21vh" }
                },
                [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnAgregarPromo" },
                      on: { click: _vm.btnAgregarPromo }
                    },
                    [_vm._v("AGREGAR COMBOS")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "btnCarrito" },
                      on: { click: _vm.btnCarrito }
                    },
                    [_vm._v("IR AL CARRITO")]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.seleccion == 4 && !_vm.mobileView,
                expression: "seleccion==4 && !mobileView"
              }
            ],
            attrs: { seleccion: _vm.seleccion }
          },
          [
            _c("div", {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100vh",
                background: "#000000",
                opacity: "0.6",
                filter: "alpha(opacity=60)"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  width: "400px",
                  "border-radius": "15px",
                  "box-sizing": "border-box",
                  border: "1px solid #dddddd",
                  background: "white"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: {
                      "margin-top": "10px",
                      height: "20px",
                      "padding-right": "10px"
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "20px", height: "20px" },
                      attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                      on: { click: _vm.btnCerrarPopup }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh ct",
                    staticStyle: { width: "100%", "margin-top": "10px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { width: "45%", height: "200px" }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "90%",
                            height: "90%",
                            "object-fit": "contain"
                          },
                          attrs: { src: _vm.imagenProducto }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "fh cc", staticStyle: { width: "55%" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "margin-top": "0px",
                                  "font-size": "15px",
                                  color: "#5C666F",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v(_vm._s(_vm.nombreProducto))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "margin-top": "5px",
                                  "font-size": "11px",
                                  color: "#5C666F",
                                  "font-weight": "500"
                                }
                              },
                              [_vm._v(_vm._s(_vm.descripcionProducto))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh lc",
                                staticStyle: {
                                  "margin-top": "10px",
                                  "font-size": "13px",
                                  color: "#4969B2",
                                  "font-weight": "500"
                                }
                              },
                              [
                                _vm._v(
                                  "Precio $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.compPrecio)
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh cc",
                                staticStyle: {
                                  width: "100%",
                                  "margin-top": "25px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh lc",
                                    staticStyle: {
                                      width: "40%",
                                      "font-size": "11px",
                                      color: "#5C666F"
                                    }
                                  },
                                  [_vm._v("CANTIDAD")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh lc",
                                    staticStyle: { width: "60%" }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cantidadProducto,
                                          expression: "cantidadProducto"
                                        }
                                      ],
                                      class: {
                                        popupCantidad: _vm.cantValida,
                                        popupCantidadInv: !_vm.cantValida
                                      },
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.cantidadProducto },
                                      on: {
                                        keyup: _vm.updateCantidad,
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.cantidadProducto =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-left": "5px",
                                          "font-size": "11px",
                                          color: "#5C666F"
                                        }
                                      },
                                      [_vm._v("unid")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh cc",
                                staticStyle: {
                                  width: "100%",
                                  "margin-top": "8px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh lc",
                                    staticStyle: {
                                      width: "40%",
                                      "font-size": "11px",
                                      color: "#5C666F"
                                    }
                                  },
                                  [_vm._v("SUBTOTAL")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh lc",
                                    staticStyle: {
                                      width: "60%",
                                      "font-size": "16px",
                                      color: "#5C666F",
                                      "font-weight": "500"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm._f("formatMoney")(_vm.subtotal)
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { id: "btnContainerPopup" }
                  },
                  [
                    _c(
                      "button",
                      {
                        attrs: { id: "btnCerrarPopup" },
                        on: { click: _vm.btnCerrarPopup }
                      },
                      [_vm._v("CANCELAR")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: { id: "btnAgregarPopup" },
                        on: { click: _vm.btnAgregar }
                      },
                      [_vm._v("DEVOLVER")]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.seleccion == 4 && _vm.mobileView,
                expression: "seleccion==4  && mobileView"
              }
            ],
            attrs: { seleccion: _vm.seleccion }
          },
          [
            _c("div", {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                background: "#000000",
                opacity: "0.8",
                filter: "alpha(opacity=80)"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  width: "96vw",
                  height: "84vh",
                  "min-height": "480px",
                  background: "white",
                  top: "8%",
                  left: "2%",
                  "z-index": "10"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh rb",
                    staticStyle: { width: "100%", height: "8%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "30px",
                        height: "30px",
                        "margin-right": "10px"
                      },
                      attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                      on: { click: _vm.btnCerrarPopup }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "8%",
                      "font-size": "20px",
                      "font-weight": "600"
                    }
                  },
                  [_vm._v(_vm._s(_vm.nombreProducto))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: { width: "100%", height: "25%" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: { width: "50%", height: "100%" }
                      },
                      [
                        _c("img", {
                          staticStyle: { height: "80%" },
                          attrs: { src: _vm.imagenProducto }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fv lc",
                        staticStyle: { width: "50%", height: "100%" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "0px",
                              "margin-top": "5px",
                              "font-size": "14px",
                              "font-weight": "400"
                            }
                          },
                          [_vm._v(_vm._s(_vm.descripcionProducto))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "0px",
                              "margin-top": "20px",
                              "font-size": "25px",
                              "font-weight": "800"
                            }
                          },
                          [
                            _vm._v(
                              "$" +
                                _vm._s(_vm._f("formatMoney")(_vm.compPrecio))
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "6%",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fv lc",
                        staticStyle: {
                          "margin-left": "40px",
                          width: "40%",
                          height: "100%",
                          "font-size": "14px"
                        }
                      },
                      [_vm._v(" \n             CANTIDAD\n           ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh rc",
                        staticStyle: { width: "60%", height: "100%" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cantidadProducto,
                              expression: "cantidadProducto"
                            }
                          ],
                          class: {
                            popupCantidad: _vm.cantValida,
                            popupCantidadInv: !_vm.cantValida
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.cantidadProducto },
                          on: {
                            keyup: _vm.updateCantidad,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cantidadProducto = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "50px",
                              "margin-left": "10px",
                              "margin-right": "10px"
                            }
                          },
                          [_vm._v("unid")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh ct",
                    staticStyle: { width: "100%", height: "5%" }
                  },
                  [
                    _c("div", {
                      staticClass: "fv cc",
                      staticStyle: { width: "40%", height: "100%" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: { width: "100%", height: "15%" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fv lc",
                        staticStyle: {
                          "margin-left": "40px",
                          width: "40%",
                          height: "100%",
                          "font-size": "14px"
                        }
                      },
                      [_vm._v("SUBTOTAL")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fv cc",
                        staticStyle: {
                          width: "60%",
                          height: "100%",
                          "font-size": "25px",
                          "font-weight": "800"
                        }
                      },
                      [
                        _vm._v(
                          "$" + _vm._s(_vm._f("formatMoney")(_vm.subtotal))
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cb",
                    staticStyle: { width: "100%", height: "15%" }
                  },
                  [
                    _c(
                      "button",
                      {
                        attrs: { id: "btnCerrarPopup" },
                        on: { click: _vm.btnCerrarPopup }
                      },
                      [_vm._v("CANCELAR")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: { id: "btnAgregarPopup" },
                        on: { click: _vm.btnAgregar }
                      },
                      [_vm._v("AGREGAR AL CARRITO")]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Nueva Devolución")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-746812ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746812ae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarDevolucion/realizarDevolucion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-746812ae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarDevolucion/realizarDevolucion.vue
// module chunks = 0